import GenericModel from '../generic-model';
import Company from '../company/company';
import { Telephone } from '../telephone';
import { Email } from '../email';

export default class Contact extends GenericModel {
  archived?: boolean;
  firstName?: string;
  lastName?: string;
  emails?: Email[];
  telephones?: Telephone[];
  companies?: Company[];
  gender?: string;
  birthdate?: string;
  salutation?: string;
  personalInfo?: string;
  type?: string;

  // Only for display in project form or contacts table
  phoneNumberDisplay?: string;
  mobileNumberDisplay?: string;
  emailDisplay?: string;

  // Only for detail
  lastLogin?: string;
  contactUserId?: number;

  constructor() {
    super();
    this.emails = [];
    this.telephones = [];
    this.companies = [];
  }
}
